import PropsTypes from "prop-types";

const providerLineRefundProps = {
  type: {
    showModal: PropsTypes.bool.isRequired,
    orderToInitiate: PropsTypes.object.isRequired,
    onClose: PropsTypes.func.isRequired,
  },
};

export default providerLineRefundProps;
